// extracted by mini-css-extract-plugin
export var cardTitle = "_i5-1";
export var commentBubble = "_i5-e";
export var commentForm = "_i5-a";
export var commentInput = "_i5-b";
export var commentLabel = "_i5-d";
export var commentPrompt = "_i5-9";
export var csatCard = "_i5-0";
export var feedbackSection = "_i5-7";
export var starDisabled = "_i5-6";
export var starEmpty = "_i5-5";
export var starFilled = "_i5-4";
export var starWrapper = "_i5-3";
export var starsContainer = "_i5-2";
export var submittedComment = "_i5-c";
export var thankYouText = "_i5-8";